module.exports = __webpack_public_path__ + "static/music-v3.7cdbea42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/music-v3.jpg
// module id = 355
// module chunks = 35783957827783